import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessAccidentMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-accident-metadata/business-accident-metadata.component.abstract';
import { SharedBusinessMetadataV2Component } from '../shared-business-metadata-v2/shared-business-metadata-v2.component';

@Component({
  selector: 'app-business-accident-metadata-v2',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    SharedBusinessMetadataV2Component,
    CustomDatePipe,
  ],
  templateUrl: './business-accident-metadata-v2.component.html',
})
export class BusinessAccidentMetadataV2Component extends BusinessAccidentMetadataComponentAbstract {}
